import { Contract } from '../../../../types/contract'
import { useDonationAmountValidation } from '../../../../hooks/contracts/validations/DonationAmountValidationHook'
import React, { useCallback, useEffect, useState } from 'react'
import { RecurrenceInterval } from '../../../../types/recurring-interval'
import { DonationType } from '../../../../enums/donation-type'
import { translations } from '../../../../utils/translations/translations-manager'
import { ContractAmountInput } from '../inputs/ContractAmountInput'
import { ContractRecurrenceInput } from '../inputs/ContractRecurrenceInput'
import { FilledButton } from '../../common/buttons/FilledButton'
import { Recurrence } from '../../../../types/donation/recurrence'

export function ContractCompletion({ contract, success }: { contract: Contract; success: () => void }): JSX.Element {
  const { validate, amount, setAmount, validationError } = useDonationAmountValidation(contract.selectedDonationAmount, true)
  const [recurrence, setRecurrence] = useState<Recurrence | undefined>((contract.subscriptionRecurrence && contract.subscriptionRecurrenceCount) ? { interval: contract.subscriptionRecurrence, count: contract.subscriptionRecurrenceCount } : undefined)
  const [donationType] = useState<DonationType | undefined>(contract.contractType)
  const [recurrenceValidationError, setRecurrenceValidationError] = useState<boolean>(false)
  const [donationTypeValidationError, setDonationTypeValidationError] = useState<boolean>(false)

  const onComplete = useCallback(() => {
    if (validate() && validateRecurrence() && validateDonationType()) {
      contract.selectedDonationAmount = amount
      contract.donationAmount = amount
      contract.subscriptionRecurrence = recurrence?.interval
      contract.subscriptionRecurrenceCount = recurrence?.count
      success()
    }
  }, [validate, amount, recurrence, success])

  const validateRecurrence = useCallback(() => {
    if (donationType === DonationType.recurring && !recurrence) {
      setRecurrenceValidationError(true)
      return false
    }
    setRecurrenceValidationError(false)
    return true
  }, [donationType, recurrence])

  const validateDonationType = useCallback(() => {
    if (!donationType) {
      setDonationTypeValidationError(true)
      return false
    }
    return true
  }, [donationType])

  useEffect(() => {
    validateRecurrence()
  }, [validateRecurrence])

  return (
    <>
      <div className={'flex flex-col gap-4'}>
        <div className={'flex flex-col gap-2'}>
          <h5 className={'font-medium'}>{translations.texts.amount.toString()}</h5>
          <ContractAmountInput value={amount} setValue={setAmount} error={validationError ? translations.texts.invalid_amount.toString() : undefined} />
        </div>
        <div className={'flex flex-col gap-2'}>
          <h5 className={'font-medium'}>{translations.texts.recurrence.toString()}</h5>
          <ContractRecurrenceInput
            value={recurrence}
            setValue={setRecurrence}
            error={recurrenceValidationError ? translations.texts.invalid_contract_recurrence.toString() : undefined}
          />
        </div>
      </div>
      <FilledButton
        className={'mt-8'}
        onClick={onComplete}
        label={translations.texts.confirm.toString()}
        disabled={validationError !== undefined || recurrenceValidationError || donationTypeValidationError}
      />
    </>
  )
}
